<div class="drag-drop">
  <input type="file" class="inputfile" (change)="selectFile($event)" (click)="clearInput($event)" [id]="id" [name]="id" [accept]="accept"
  />
  <label [for]="id" data-error="Invalid File Type">
    <div class="upload-icon">
      <img src="../../../assets/images/upload-web.png" />
    </div>
    <p class="center">
      <span class="file-upload-note largeText" [innerHTML]="largeText"></span>
      <span class="file-upload-note smallText" *ngIf="!labelButton">
        <span class="plus">+</span>
        <span [textContent]="smallText"></span>
      </span>
      <button type="button" class="btn zest-btn-2 zest-upload-btn" *ngIf="labelButton">
        <span [textContent]="buttonText"></span>
      </button>
    </p>
  </label>
</div>
<div *ngIf="isPDF || isImg" id="documentPreviewModal" class="modal" materialize="modal" [materializeParams]="[{dismissible: true}]">
  <div class="modal-header closeDivision" (click)="closeModal()">
    <i class="small material-icons">close</i>
  </div>
  <div class="modal-content center">
    <div class="pdfViewer" *ngIf="!loadingFile && isPDF && !isImg && (!passwordRequired || (passwordRequired && passwordValidated))">
      <pdf-viewer [src]="documentSrc" [page]="currentPage" [fit-to-page]="true" [render-text]="true" [show-all]="false" [stick-to-page]="true"
        style="display: block;" (error)="onError($event)" (after-load-complete)="pdfLoadingComplete($event)"></pdf-viewer>
    </div>
    <div class="documentPasswordReceived" *ngIf="!loadingFile && isPDF && !isImg && passwordRequired && !passwordValidated">
      <i class="large lock-blue material-icons">lock</i>
      <p class="passwordProtectedDocumentMessage">The document is password protected.</p>
      <div class="documentPasswordInputDivision">
        <input materialize (keyup)="validatePasswordInput()" (keyup.enter)="fetchDocumentPassword()" placeholder="Enter password"
          [(ngModel)]="docPassword" #documentPasswordInput class="documentPasswordInput validate" minlength="1" [type]="viewPassword ? 'text' : 'password'"
          required>
        <i class="small grayEye passwordViewer material-icons" [class.greenEye]="viewPassword" (click)="viewPassword = !viewPassword">remove_red_eye</i>
      </div>
      <p class="errorMessage" *ngIf="errorMessage" [textContent]="errorMessage"></p>
    </div>
    <img [src]="documentSrc" *ngIf="!loadingFile && !isPDF && isImg" class="imageViewer">
    <p *ngIf="loadingFile" class="loadingFile">Loading Content...</p>
  </div>
  <div class="modal-footer" *ngIf="!loadingFile">
    <button type="button" *ngIf="!processing && (!isPDF || !passwordRequired || (passwordRequired && passwordValidated))" (click)="upload()"
      class="btn zest-btn documentPreviewModalButton" [textContent]="'Submit'"></button>
    <button *ngIf="!processing && passwordRequired && !passwordValidated" (click)="fetchDocumentPassword()" type="button" class="btn zest-btn documentPreviewModalButton">
      <i class="small material-icons">arrow_forward</i>
    </button>
    <button type="button" *ngIf="processing" class="btn zest-btn documentPreviewModalButton" [textContent]="'Please Wait...'"
      disabled></button>
  </div>
</div>
